module["exports"] = [
  "연구소",
  "게임즈",
  "그룹",
  "전자",
  "물산",
  "코리아"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ko/company/suffix.js
// module id = 3207
// module chunks = 1610